import { useTranslation } from 'react-i18next';
import { Eye, X } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';

/**
 * Sticky banner shown to a SuperAdmin while their view is scoped to a tenant
 * (header TenantSwitcher / "View as Tenant"). Makes the active tenant obvious
 * and gives a one-click way back to the global SuperAdmin view.
 */
export function ImpersonationBanner() {
  const { t } = useTranslation();
  const role = useAuthStore((s) => s.role);
  const impersonatedTenantId = useAuthStore((s) => s.impersonatedTenantId);
  const impersonatedTenantName = useAuthStore((s) => s.impersonatedTenantName);
  const setImpersonatedTenant = useAuthStore((s) => s.setImpersonatedTenant);

  if (role !== 'superadmin' || impersonatedTenantId === null) return null;

  const name = impersonatedTenantName || `#${impersonatedTenantId}`;

  return (
    <div className="flex items-center justify-between gap-3 bg-primary-600 px-4 py-2 text-sm font-medium text-white">
      <span className="flex items-center gap-2">
        <Eye className="h-4 w-4 shrink-0" />
        {t('layout.impersonationBanner.viewing', { name })}
      </span>
      <button
        type="button"
        onClick={() => setImpersonatedTenant(null)}
        className="flex items-center gap-1 rounded-md bg-white/15 px-3 py-1 transition-colors hover:bg-white/25"
      >
        <X className="h-4 w-4" />
        {t('layout.impersonationBanner.exit')}
      </button>
    </div>
  );
}
